import { ON_PHONE_READ, ON_PHONE_READING } from '../actions/types';

const INITIAL_STATE = { phones: [], loading: false };

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ON_PHONE_READING:
      return { ...state, loading: true };
    case ON_PHONE_READ:
      return { ...state, phones: action.payload, loading: false };
    default:
      return state;
  }
};
